export default function renderSidebarAccordion(ancestor = document) {
  const closePanel = (accordion, panel) => {
    panel.style.height = `${panel.scrollHeight}px`;
    panel.offsetHeight;
    panel.style.height = "0px";
    accordion.classList.remove("open");
  };

  const openPanel = (accordion, panel) => {
    accordion.classList.add("open");

    const targetHeight = panel.scrollHeight;
    panel.style.height = "0px";
    panel.offsetHeight;
    panel.style.height = `${targetHeight}px`;
  };

  ancestor.querySelectorAll(".sidebar-accordion .js-accordion__header").forEach((header) => {
    if (header.dataset.sidebarAccordionBound === "true") {
      return;
    }

    header.dataset.sidebarAccordionBound = "true";

    const accordion = header.closest(".sidebar-accordion");
    const panel = accordion?.querySelector(".js-accordion__panel");
    if (!accordion || !panel) {
      return;
    }

    panel.style.height = accordion.classList.contains("open") ? "auto" : "0px";

    panel.addEventListener("transitionend", (event) => {
      if (event.propertyName !== "height") {
        return;
      }

      if (accordion.classList.contains("open")) {
        panel.style.height = "auto";
      }
    });

    header.addEventListener("click", (event) => {
      event.preventDefault();

      if (accordion.classList.contains("open")) {
        closePanel(accordion, panel);
        return;
      }

      openPanel(accordion, panel);
    });
  });
}
